import { Component, OnDestroy, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

/* State and Services */
import { AppSelectors } from 'src/app/core/store/app/app.selectors';

/* Models */
import { TreeNode } from 'src/app/core/models/tree-node.model';
import { NodeTypes } from '@core/enums';

/* Utils */
import { getParentNode } from '@core/utils/common-functions';

@Component({
	selector: 'app-sidebar-menu',
	templateUrl: './sidebar-menu.component.html',
	styleUrls: ['./sidebar-menu.component.scss'],
	animations: [
		trigger('slideVertical', [
			state('*', style({ height: 0 })),
			state('show', style({ height: '*' })),
			transition('* => *', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
		]),
	],
})
export class SidebarMenuComponent implements OnInit, OnDestroy {
	@Select(AppSelectors.activeNode) activeNode$: Observable<TreeNode>;
	@Select(AppSelectors.nodeTree) nodeTree$: Observable<TreeNode[]>;
	destroy$ = new Subject<void>();
	treeControl = new NestedTreeControl<TreeNode>((node) => node.children);
	dataSource = new MatTreeNestedDataSource<TreeNode>();

	public active: TreeNode;
	public root: TreeNode;

	constructor() {}

	hasChild = (_: number, node: TreeNode) =>
		node.children && node.children.length > 0 && node.typeId !== NodeTypes.Space;

	ngOnInit() {
		this.activeNode$
			.pipe(
				takeUntil(this.destroy$),
				filter((activeNode) => activeNode !== null),
			)
			.subscribe((activeNode) => {
				this.active = activeNode;
				this.root = activeNode.parent ? getParentNode(activeNode) : activeNode;
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	/**
	 * Toggle clicked tree node
	 */
	toggleNode(node: TreeNode) {
		if (this.treeControl.isExpanded(node)) {
			this.treeControl.collapse(node);
		} else {
			this.treeControl.expand(node);
		}
	}

	isActive(node: TreeNode) {
		return node === this.active || node === this.root ? 'active' : '';
	}
}
